import script from "./AwaitOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./AwaitOrders.vue?vue&type=script&setup=true&lang=js"

import "./AwaitOrders.vue?vue&type=style&index=0&id=7b82614a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b82614a"]])

export default __exports__